import { render, staticRenderFns } from "./TermsAndAgreement.vue?vue&type=template&id=34924bd6&scoped=true"
import script from "./TermsAndAgreement.vue?vue&type=script&lang=js"
export * from "./TermsAndAgreement.vue?vue&type=script&lang=js"
import style0 from "./TermsAndAgreement.vue?vue&type=style&index=0&id=34924bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34924bd6",
  null
  
)

export default component.exports